(ns ui.skeleton
  (:require [ui.utils :refer [clsx]]))


(defn skeleton [{:keys [height width] :as props}]
  [:div (-> props
            (dissoc :height :width)
            (update :class #(clsx "bg-kleene-selected-background rounded-md animate-kleene-pulse" %))
            (update :style #(merge {:height (or height 16) :width width} %)))])
